import { Component, OnInit, ViewChildren } from '@angular/core';
import { Service } from '../../../models';
import { DialogService, ServicesService, SnackbarService } from '../../../services/standard';
import { DownloadService } from '../../../services/standard/download.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'prism-show-downloads',
  templateUrl: './show-downloads.component.html',
  styleUrls: ['./show-downloads.component.scss']
})
export class ShowDownloadsComponent implements OnInit {

  downloadData$ = this.downloadService.downloadData$
    .pipe(
      map(downloadData => {
        return Object.entries(downloadData);
      })
    );
  job: Service;
  private address: string;
  downloadSizes = {};

  constructor(private downloadService: DownloadService,
              private dialogService: DialogService,
              private snackbarService: SnackbarService,
              private servicesService: ServicesService) {
  }

  @ViewChildren('downloadAll') atags;

  private expandRejectionItems(downloadData: any): any {
    const expanded: { [key: string]: any[] } = {};
    Object.entries(downloadData).forEach(([key, value]: [string, any]) => {
      if (key === 'rejection' && Array.isArray(value)) {
        value.forEach((item, idx) => {
          expanded[`rejection_${idx}`] = [item];
        });
      } else {
        expanded[key] = value;
      }
    });
    return expanded;
  }

  ngOnInit() {
    const downloadData = this.expandRejectionItems(this.dialogService.inputData.downloadData);
    this.downloadService.downloadData = downloadData;
    this.downloadSizes = Object.entries(downloadData).reduce((acc, [timestamp, downloadBatch]) => {
      (<any[]>downloadBatch).forEach(({size}) => {
        acc.all += size;
        if (!acc[timestamp]) {
          acc[timestamp] = 0;
        }

        acc[timestamp] += size;
      });

      return acc;
    }, {all: 0});

    this.job = this.dialogService.inputData.job;
    this.address = this.job.address;
    if (this.job.notifications && this.job.notifications.newRaws) {
      this.servicesService.clearNotification(this.job, 'newRaws')
        .toPromise()
        .then(() => {
          this.job.notifications.newRaws = false;
        })
        .catch(e => {
          console.error('Could not clear notifications:', e);
          this.snackbarService.handleError('Could not clear notifications');
        });
    }
  }

  downloadFile(downloadData, batchNum) {
    const [firstFileData] = downloadData[1];
    const jobId = firstFileData.path.split('_')[0];
    this.downloadService.sendDownloadRequest(this.address, `Service_${jobId}`, downloadData[1], batchNum, false, true);
  }

  downloadAllAssets(downloadData) {
    const [firstFileData] = downloadData[0][1];
    const jobId = firstFileData.path.split('_')[0];
    this.downloadService.sendDownloadRequest(this.address, `Service_${jobId}`, downloadData, null, true, true);
  }
}
